import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import Logo from "../components/Logo";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/reset-request", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-white grid place-items-center p-6" data-testid="forgot-password-page">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_30%_20%,#D4AF37,transparent_60%)]" />
      <div className="relative w-full max-w-md">
        <div className="text-center">
          <Logo className="w-20 h-20 mx-auto" />
          <h1 className="font-serif text-3xl mt-6 leading-tight">Mot de passe oublié</h1>
          <p className="mt-2 text-white/65 text-sm">Saisissez votre email pour recevoir un lien de réinitialisation.</p>
        </div>
        {sent ? (
          <div className="mt-10 bg-white text-foreground p-8 rounded-sm shadow-2xl text-center space-y-4" data-testid="reset-sent">
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500" />
            <p className="font-serif text-xl text-ink leading-snug">
              Si cette adresse est connue,<br/>un email vient d'être envoyé.
            </p>
            <p className="text-sm text-foreground/60">Vérifiez votre boîte de réception et vos spams. Le lien expire dans 60 minutes.</p>
            <Link to="/admin/connexion" className="inline-flex items-center gap-1.5 text-sm text-ink font-semibold hover:text-gold-dark mt-3" data-testid="back-to-login">
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 bg-white text-foreground rounded-sm p-8 space-y-4 shadow-2xl">
            <div>
              <label className="block text-[0.7rem] uppercase tracking-[0.16em] font-semibold text-foreground/60 mb-2">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-foreground/40" />
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       className="w-full border border-border rounded-sm pl-10 pr-3 py-3 text-sm focus:border-ink outline-none"
                       data-testid="forgot-email" />
              </div>
            </div>
            <button disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
              {loading ? "…" : <>Envoyer le lien <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
        )}
        <div className="mt-6 text-center text-sm text-white/55">
          <Link to="/" className="hover:text-gold">← Retour au site</Link>
        </div>
      </div>
    </div>
  );
}
